// redux/productFilterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const productFilterSlice = createSlice({
  name: "productFilter",
  initialState: {
    category: "All Products",
    search: "",
  },
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { setCategory, setSearch } = productFilterSlice.actions;
export default productFilterSlice.reducer;
